module.exports = __webpack_public_path__ + "bank_order_fr.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_order_fr.png
// module id = 1907
// module chunks = 0